var module = 'main', name = 'main/assets/svg/checkmark-icon.svg', content = "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 15\"><path fill=\"#ffffff\" fill-rule=\"evenodd\" d=\"M 6.49 11.06 C 5.17 9.89 3.92 8.77 2.65 7.67 C 2.41 7.45 2.11 7.25 1.81 7.16 C 1.13 6.96 0.46 7.3 0.12 7.93 C -0.22 8.57 -0.08 9.34 0.54 9.91 C 2.17 11.38 3.82 12.84 5.46 14.29 C 6.66 15.35 7.46 15.23 8.34 13.87 C 10.68 10.24 13.03 6.6 15.37 2.97 C 15.51 2.74 15.67 2.51 15.78 2.27 C 16.12 1.56 15.9 0.7 15.27 0.27 C 14.67 -0.16 13.86 -0.07 13.34 0.51 C 13.12 0.76 12.94 1.05 12.76 1.34 C 10.68 4.55 8.62 7.76 6.49 11.06 L 6.49 11.06 Z M 6.49 11.06\"/></svg>";
angular.module(module).run(['$templateCache', function($templateCache) {
  $templateCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./main/assets/svg/checkmark-icon.svg
// module id = 1291
// module chunks = 0